import { PracticeVertical } from './constants';

export const checkIsOtherVerticalSelected = (
  currentValue?: PracticeVertical,
  selectedValue?: PracticeVertical
): boolean => currentValue === PracticeVertical.Other && selectedValue === PracticeVertical.Other;

export const checkIsOtherServiceSelected = (currentValue?: string, selectedValue?: string): boolean =>
  currentValue === 'OTHER' && selectedValue === 'OTHER';
